import React, {useEffect, useState} from 'react';
import _axios from "../../../../../httpService";
import {prefixUrl} from "../../../../../utils/utilsData";
import {toast} from "react-toastify";
import Loader from "../../../../Loader";
import TableWithPagination from "./TableWithPagination";
import DynaSelectBox from "../../../DynaView/DynaSelectBox";
import DynaInput from "../../../DynaView/DynaInput";

const TodayFollowUp = ({setActiveTab, setLeadIdFromList, leadIdFromList}) => {

  const [initialData, setInitialData] = useState({})
  const [tableData, settableData] = useState({});
  const [isLoad, setIsLoad] = useState(false);
  const [reRender, setReRender] = useState(0);
  const [filterValue, setFilterValue] = useState({
    fullName: "",
    leadId: "",
    alarmType: "today",
    lastCall: "",
    lastStatus: ""
  })

  const getInitialData = async (mode) => {
    const formData = new FormData();
    if (mode === "delete") {
      formData.append("fullName", "")
      formData.append("leadId", "")
      setFilterValue({
        fullName: "",
        leadId: "",
        alarmType: "today",
        lastCall: "",
        lastStatus: ""
      })
    } else {
      formData.append("alarmType", filterValue?.alarmType)
      formData.append("fullName", filterValue?.fullName)
      formData.append("leadId", filterValue?.leadId)
      formData.append("lastCall", filterValue?.lastCall)
      formData.append("lastStatus", filterValue?.lastStatus)
    }

    const response = await _axios.post(prefixUrl() + "/sadenMarketingCRM/?request=todayFollowUps", formData)
    if (response?.data?.status) {
      settableData(response.data.data)
      void getFilterData()
    } else {
      toast.error(response.data.message)
    }
  }

  const getFilterData = async () => {
    const response = await _axios.get(prefixUrl() + "/sadenMarketingCRM/?request=followUpFormData")
    if (response?.data?.status) {
      setInitialData(response.data.data)
      setIsLoad(true)
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    void getInitialData()
  }, [reRender]);

  useEffect(() => {
    if (leadIdFromList) {
      const timer = setTimeout(() => {
        setLeadIdFromList("")
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, []);

  try {
    return (
      <>
        {isLoad ?
          <div className={"LeadsList"}>
            <div className={"box-filter box-filter-4"}>
              <div className="radio-button-group" style={{gridColumn: "1/3"}}>
                <h5>پیگیری</h5>
                <div className={"parent-row"} style={{gridTemplateColumns: 'repeat(2, 1fr)'}}>
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="call_result"
                      value={filterValue.alarmType}
                      checked={filterValue.alarmType === "today"}
                      onChange={() => setFilterValue({...filterValue, alarmType: "today"})}
                      className="radio-input"
                    />
                    <span className="custom-radio"></span>
                    پیگیری های امروز
                  </label>
                  <label className="radio-label">
                    <input
                      type="radio"
                      name="call_result"
                      value={filterValue.alarmType}
                      checked={filterValue.alarmType === "all"}
                      onChange={() => setFilterValue({...filterValue, alarmType: "all"})}
                      className="radio-input"
                    />
                    <span className="custom-radio"></span>
                    همه پیگیری ها
                  </label>
                </div>
              </div>
              <DynaSelectBox options={initialData?.leadIdArray}
                             hasFilter={true}
                             label={"کد لید"}
                             className={"solid-dyna-input"}
                             value={filterValue?.leadId}
                             onChange={(data) => setFilterValue({
                               ...filterValue,
                               leadId: data.value,
                             })}
              />
              <DynaSelectBox options={tableData?.selectBoxValues?.lastCallOptions}
                             hasFilter={true}
                             label={"نتیجه تماس"}
                             className={"solid-dyna-input"}
                             value={filterValue?.lastCall}
                             onChange={(data) => setFilterValue({
                               ...filterValue,
                               lastCall: data.value,
                             })}
              />
              <DynaSelectBox options={tableData?.selectBoxValues?.lastStatusOptions}
                             hasFilter={true}
                             label={"آخرین وضعیت"}
                             className={"solid-dyna-input"}
                             value={filterValue?.lastStatus}
                             onChange={(data) => setFilterValue({
                               ...filterValue,
                               lastStatus: data.value,
                             })}
              />
              <DynaInput label={"نام و نام خانوادگی"}
                         name={"fullName"}
                         className={"solid-dyna-input"}
                         placeholder={"نام و نام خانوادگی"}
                         value={filterValue?.fullName}
                         type={"text"}
                         setDataFromComponent={(data) => {
                           setFilterValue({...filterValue, ...data})
                         }}
              />

              <div className={"search-button"}>
                <button onClick={getInitialData}>جستجو</button>
                <button onClick={() => getInitialData("delete")}>حذف فیلتر</button>
              </div>
            </div>
            <TableWithPagination columns={tableData?.columns}
                                 data={tableData?.data}
                                 setActiveTab={setActiveTab}
                                 setReRender={setReRender}
                                 setLeadIdFromList={setLeadIdFromList}
                                 hasCloseIcon={true}
                                 closeFunction={"TodayFollowUp"}
                                 focusRowId={leadIdFromList}
                                 defaultTowsPerPage={8}/>
          </div> : <Loader/>
        }
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default TodayFollowUp;